import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useState } from "react";
import Api from "../../Auth/Api";
import { decodeJWT } from "../../Components/jwtUtils";

function ModalCancelarAgendamento({ show, onHide, agendamento, onSuccess }) {
    const token = JSON.parse(localStorage.getItem("user_token"));
    const nivel = decodeJWT(token).nivel;
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [showAlerta, setShowAlerta] = useState(false);
    const [mensagemAlerta, setMensagemAlerta] = useState('');

    const validarAntecedencia48Horas = () => {
        // Apenas Administradores podem cancelar sem restrição de 48 horas
        if (nivel === 'Administrador') {
            return true;
        }

        if (!agendamento?.data_treinamento || !agendamento?.hora_treinamento) {
            return false;
        }

        // Criar data/hora do treinamento
        let dataTreinamento;
        if (typeof agendamento.data_treinamento === 'string' && agendamento.data_treinamento.match(/^\d{4}-\d{2}-\d{2}$/)) {
            const [ano, mes, dia] = agendamento.data_treinamento.split('-');
            dataTreinamento = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia));
        } else {
            dataTreinamento = new Date(agendamento.data_treinamento);
        }

        // Adicionar hora ao objeto Date
        const horaParts = agendamento.hora_treinamento.split(':');
        dataTreinamento.setHours(parseInt(horaParts[0]), parseInt(horaParts[1]), 0, 0);

        // Se a data já passou, não permitir cancelamento
        const agora = new Date();
        if (dataTreinamento < agora) {
            return false;
        }

        // Calcular diferença em horas
        const diffMs = dataTreinamento.getTime() - agora.getTime();
        const diffHoras = diffMs / (1000 * 60 * 60);

        // Deve ter pelo menos 48 horas de antecedência
        return diffHoras >= 48;
    };

    const onSubmit = async (data) => {
        // Validar antecedência de 48 horas (exceto para admin)
        if (!validarAntecedencia48Horas()) {
            // Verificar se a data já passou
            let dataTreinamento;
            if (agendamento?.data_treinamento && agendamento?.hora_treinamento) {
                if (typeof agendamento.data_treinamento === 'string' && agendamento.data_treinamento.match(/^\d{4}-\d{2}-\d{2}$/)) {
                    const [ano, mes, dia] = agendamento.data_treinamento.split('-');
                    dataTreinamento = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia));
                } else {
                    dataTreinamento = new Date(agendamento.data_treinamento);
                }
                const horaParts = agendamento.hora_treinamento.split(':');
                dataTreinamento.setHours(parseInt(horaParts[0]), parseInt(horaParts[1]), 0, 0);
                
                if (dataTreinamento < new Date()) {
                    setMensagemAlerta('Não é possível cancelar um agendamento que já passou.');
                } else {
                    setMensagemAlerta('Os agendamentos só podem ser cancelados com no mínimo 48 horas de antecedência. Entre em contato com o setor de agendamento para cancelamentos com menos tempo.');
                }
            } else {
                setMensagemAlerta('Os agendamentos só podem ser cancelados com no mínimo 48 horas de antecedência. Entre em contato com o setor de agendamento para cancelamentos com menos tempo.');
            }
            setShowAlerta(true);
            return;
        }

        try {
            await Api.post(`/api/agendamentos-treinamentos/${agendamento.id}/cancelar`, data, {
                headers: { Authorization: `Bearer ${token}` }
            });
            onSuccess();
        } catch (error) {
            setMensagemAlerta(error.response?.data?.message || 'Erro ao cancelar agendamento');
            setShowAlerta(true);
        }
    };

    if (!agendamento) return null;

    return (
        <>
        <Modal size='lg' show={show} onHide={onHide} backdrop="static">
            <Modal.Header closeButton>
                <span className="fw-semibold fs-5 text-primary">Cancelar Agendamento</span>
            </Modal.Header>
            <Modal.Body className="bg-gray-100 p-4">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-3">
                        <label className="form-label text-primary fw-medium">Justificativa <span className="text-danger">*</span></label>
                        <textarea
                            className="form-control border-new-light"
                            rows="4"
                            {...register('justificativa', { required: true })}
                            placeholder="Informe o motivo do cancelamento..."
                        />
                        {errors.justificativa && <span className="text-danger fs-7">Justificativa é obrigatória.</span>}
                    </div>
                    {nivel === 'Administrador' && (
                        <div className="mb-3">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="cobrarTaxa"
                                    {...register('cobrar_taxa')}
                                />
                                <label className="form-check-label text-primary fw-medium" htmlFor="cobrarTaxa">
                                    Cobrar Taxa
                                </label>
                            </div>
                        </div>
                    )}
                </form>
            </Modal.Body>
            <Modal.Footer className="justify-content-end">
                <div className="d-flex justify-content-end">
                    <button type="button" className="btn me-2" onClick={onHide}>
                        Voltar
                    </button>
                    <button type="button" className="btn btn-danger" onClick={handleSubmit(onSubmit)}>
                        Cancelar Agendamento
                    </button>
                </div>
            </Modal.Footer>
        </Modal>

        {/* Modal de Alerta */}
        <Modal show={showAlerta} onHide={() => setShowAlerta(false)} centered>
            <Modal.Header closeButton className="border-0">
                <Modal.Title className="text-danger">
                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                    Erro
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="alert alert-danger mb-0" role="alert">
                    {mensagemAlerta}
                </div>
            </Modal.Body>
            <Modal.Footer className="border-0">
                <button className="btn btn-primary" onClick={() => setShowAlerta(false)}>
                    Entendi
                </button>
            </Modal.Footer>
        </Modal>
        </>
    );
}

export default ModalCancelarAgendamento;

